import { Loader2 } from "lucide-react";

/** Minimal, on-brand loader shown while a lazily-loaded page chunk arrives. */
export function RouteFallback() {
  return (
    <div
      data-testid="route-fallback"
      className="flex min-h-[50vh] w-full items-center justify-center"
      role="status"
      aria-label="Loading"
    >
      <Loader2 className="h-6 w-6 animate-spin text-gold-light/70" />
    </div>
  );
}
